import { render } from "./ListItemComponent.vue?vue&type=template&id=0324b4c9"
import script from "./ListItemComponent.vue?vue&type=script&lang=js"
export * from "./ListItemComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__